import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/homepage/HomePage";
import ContactsPage from "./pages/contacts/ContactsPage";
import Toolbar from "./elements/toolbar/Toolbar";
import "./App.css";
import PortfolioPage from "./pages/portfolio/PortfolioPage";


export const ThemeContext = React.createContext({
	theme: "light",
	toggleTheme: () => {},
});


/**
 * Render app root element
 * @return {JSX.Element} App root directory
 */
function App(): JSX.Element {
	const [lang, setLang] = useState<string>(localStorage.getItem("lang") || "EN");
	const [theme, setTheme] = useState<string>(localStorage.getItem("theme") || "light");
	
	
	useEffect(() => {
		const root = document.documentElement;
		if (theme === "dark") {
			root.style.setProperty("--bg-color", "black");
			root.style.setProperty("--color-light", "4, 17, 103");
		} else {
			root.style.setProperty("--bg-color", "#ffffff");
			root.style.setProperty("--color-light", "96, 113, 227");
		}
	}, [theme]);
	
	const toggleTheme = () => {
		const newTheme = theme === "light" ? "dark" : "light";
		setTheme(newTheme);
		localStorage.setItem("theme", newTheme);
	};
	
	
	return (
		<div className="App">

			<ThemeContext.Provider value={{ theme, toggleTheme }}>
			
				<Router>
					
					<Toolbar
						lang={lang}
						setLang={setLang}
					/>
					
					<div className="appContent">
						
						<Routes>
							<Route index element={<HomePage lang={lang}/>} />
							<Route path="/contacts" element={<ContactsPage lang={lang}/>} />
							<Route path="/portfolio" element={<PortfolioPage lang={lang}/>} />
						</Routes>
					
					</div>
				
				</Router>
		
			</ThemeContext.Provider>
		</div>
	);
}

export default App;
